/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Show_Next_EventInputs */



/**
* | output |
* | --- |
* | "Show next event" |
*
* @param {Player_Show_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_show_next_event = /** @type {((inputs?: Player_Show_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Show_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher l'evenement suivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nächstes Ereignis anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra il prossimo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать следующее событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar próximo evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示下一个活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次のイベントを表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगला कार्यक्रम दिखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mostrar o próximo evento")
	return /** @type {LocalizedString} */ ("Show next event")
});